import { Component, OnInit, Input } from '@angular/core';
import { LocalService } from '../../../service/local.service';

@Component({
  selector: 'app-information',
  templateUrl: './information.component.html',
  styleUrls: ['./information.component.scss']
})
export class InformationComponent implements OnInit {
  @Input() message: string = ''; @Input() isRedAlert: boolean = false;
  constructor(public localService: LocalService) { }

  ngOnInit(): void {
  }

  onClose() {
    this.localService.info = '';
  }

}
